import React, {Component} from 'react';
import RedirectUrisRow from "./RedirectUrisRow";
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';

class RedirectUrisTable extends Component {
  static propTypes = {
    onRowAdd: PropTypes.func,
    onRowDel: PropTypes.func,
    onOidcRedirectUrisUpdate: PropTypes.func,
    oidcRedirectUris: PropTypes.any,
  }

  handleRowAdd = () => {
    this.props.onRowAdd();
  }

  render() {
    //Allow URI removal only in case if there are more than 1 URI
    const allowDelete = this.props.oidcRedirectUris.length > 1;
    const redirectUrisRows = this.props.oidcRedirectUris
        ? this.props.oidcRedirectUris.map(
            (oidcRedirectUri, index) =>
                <RedirectUrisRow
                    onOidcRedirectUrisUpdate={this.props.onOidcRedirectUrisUpdate}
                    oidcRedirectUri={oidcRedirectUri}
                    onRowDel={this.props.onRowDel}
                    allowDelete={allowDelete}
                    id={index}
                    key={index}/>
        ) : [];

    return (
        <div>
          <table>
            <tbody>
            {redirectUrisRows}
            <tr>
              <td className="add-attribute">
                <button type="button" onClick={this.handleRowAdd}
                        className="add-uri attr-button">
                  <span className="fa fa-plus btn-circle btn-plus"/>
                  <span
                      className="attr-button-label">{messageConstants.OIDC_ADD_URI}</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <br/>
        </div>
    );
  }

}

export default RedirectUrisTable;
